/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


//====================================
//	# CUSTOM JS
//====================================

$(document).ready(function(){
  $(document).on('click', '.mm-upsell-button', function() {
    debugger;
    var $self = $(this);
    var Vaiant = $self.parents('.upsell-product').find('[name="mm-variant"]').val();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data : {
        id: parseInt(Vaiant),
        quantity: 1
      },
      dataType: 'json',
      success: function(data) {
        $self.parents('.upsell-list-item').hide();
        window.location.reload();
      }
    })           
  })
});






//================================================
//	# Info Tab on product page and checkout page
//================================================


function openCol(evt, infoCol){
    var i;
    var productTabContent;
    var productTabLinks;

    productTabContent = document.getElementsByClassName('product-tabcontent');
    for (i = 0; i < productTabContent.length; i++){
        productTabContent[i].style.display = "none";
    }

    productTabLinks = document.getElementsByClassName('product-tablinks');
    for (i = 0; i < productTabLinks.length; i++){
        productTabLinks[i].className = productTabLinks[i].className.replace(" active", "");
    }

    document.getElementById(infoCol).style.display = "block";
    evt.currentTarget.className += " active";
    

}

document.getElementById("defaultOpen").click();



  
  
  
  //====================================
//	# shop now pay later
//====================================

    

  let payLaterAmount = document.querySelector('[data-paylater-amount]');
  
  
 

	document.addEventListener('variant:changed', function(event) {
 	var variant = event.detail.variant; // Gives you access to the whole variant details
  	payLaterAmount.innerText =  'RM'+ Math.round((variant.price/300) * 100) / 100
  
  	
 });

  